import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Doughnut } from "react-chartjs-2";
import ModalGraph from "@image/icones/DocumentsEmployers/graph.svg";
import GraphModal from "./ContentModals";
import Legende from "./Legende";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
export default React.memo(function Index({
  legends,
  graphData,
  title,
  showPagination,
  showCount,
  spaceLegende,
  customOptions,
  chartRef=null
}) {
  const [showModal, setShowModal] = useState(false);
  const [active, setActive] = useState(true);
  const [lists, setLists] = useState([]);
  //const [minHeight, setMinHeight] = useState(10);
  const [graphOptions, setGraphOptions] = useState({});
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (active && legends?.length) {
      getLists(0, 7);
    }
  }, [active, legends]);

  const getLists = (start, stop) => {
    const legend = legends?.slice(start, stop);
    setLists(legend);
  };

  useEffect(() => {
    let options = {
      tooltips: {
        bodyFontSize: 13,
        callbacks: {
          label: (tooltipItem, data) => data.labels[tooltipItem.index]
        }
      },
      legend: {
        display: false
      }
    };
    // let min_Height = 20;
    if(customOptions?.tooltips){
      options = {
        ...options,
        tooltips:{
          ...customOptions?.tooltips,
          bodyFontSize: windowDimensions?.width > 1750 ? 15 : 13,
          titleFontSize: windowDimensions?.width > 1750 ? 16 : 12,
          caretSize: 8,
        }
      }
    }else if (windowDimensions?.width > 1750) {
      //min_Height = 10;
      options = {
        // maintainAspectRatio: true,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => data.labels[tooltipItem.index]
          },
          bodyFontSize: 15,
          caretSize: 8,
          titleFontSize: 16
        },
        legend: {
          display: false
        }
      };
    }
    //setMinHeight(min_Height);
    setGraphOptions(options);
  }, [windowDimensions?.width,customOptions]);

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div className="arh-w-full arh-h-full">
        <div className="arh-flex arh-flex-col arh-w-full arh-h-full arh-mb-18 arh-p-18 arh-pl-11 arh-border arh-border-solid arh-border-borderStat">
          <div className="arh-w-full arh-flex arh-justify-between arh-items-center">
            <h3 className="arh-m-0 arh-font-poppins arh-font-bold arh-text-15 arh-text-black">
              {title}
            </h3>
            <button
              className="arh-border-0 arh-bg-transparent"
              onClick={handleShowModal}
            >
              <img alt="graph" src={ModalGraph} />
            </button>
          </div>
          <div className="arh-relative arh-flex arh-justify-between arh-items-center">
            <div className={`arh-w-5/12 ${spaceLegende}`}>
              {lists?.length
                ? lists.map((legend) => (
                    <Legende
                      //arh-max-h-36  arh-overflow-hidden arh-w-[300px] arh-h-[150px]
                      key={legend?._id || legend?.name}
                      backgroundColor={legend?.backgroundColor}
                      classParagraph="arh-font-medium"
                      className="arh-w-64"
                      name={`${legend?.name || ""} ${
                        showCount ? `(${legend?.count || 0})` : ""
                      }`}
                    />
                  ))
                : ""}
            </div>
            <div className="arh-flex arh-justify-center arh-items-center arh-w-7/12 arh-ml-4 ">
              <Doughnut ref={showModal? null : chartRef} data={graphData} options={graphOptions} />
            </div>
          </div>
          {showPagination && (
            <div className="arh-h-full arh-flex arh-justify-start arh-items-end">
              <div className="arh-w-full arh-flex arh-justify-start arh-space-x-2 arh-items-center">
                <span
                  className={`arh-w-2 arh-h-2 arh-rounded-full arh-cursor-pointer  ${
                    active
                      ? "arh-bg-[#C4C4C4]"
                      : "arh-border-[#C4C4C4] arh-border arh-border-solid arh-bg-white"
                  }
                `}
                  onClick={() => {
                    getLists(0, 7);
                    setActive(true);
                  }}
                ></span>
                <span
                  className={`arh-w-2 arh-h-2 arh-rounded-full arh-cursor-pointer ${
                    !active
                      ? "arh-bg-[#C4C4C4]"
                      : "arh-border-[#C4C4C4] arh-border arh-border-solid arh-bg-white"
                  }`}
                  onClick={() => {
                    getLists(8, 12);
                    setActive(false);
                  }}
                ></span>
              </div>
            </div>
          )}
        </div>
      </div>
      <GraphModal
        show={showModal}
        onclickClose={handleShowModal}
        fragment={Fragment}
        title={title}
        legends={legends}
        graphData={graphData}
        graphOptions={graphOptions}
        showCount={showCount}
        chartRef={chartRef}
      />
    </>
  );
});
